import { Form, Formik } from 'formik'
import { useParams } from 'react-router-dom'

import BottomSection from './BottomSection'
import TopSection from './TopSection'
import MainTitle from 'components/MainTitle'
import { useTotalCount } from 'store/server/useDashboard'
import Spinner from 'components/spinner'
import { createOrderSchema } from 'schemas/orderSchemas'

export default function AddOrderForm() {
  const { brand, dept, subDept } = useParams()
  const { data, isFetching } = useTotalCount()
  const deptId = dept.split('_')[0]

  if (isFetching) return <Spinner />

  // Özel departman için Formik initial values
  const specialInitialValues = {
    orderNo: '',
    company: '',
    customerOrderNo: '',
    changesForEveryProduct: false,
    season: '',
    country: '',
    brandOrderNo: '',
    supplierNo: '',
    articleNo: '',
    sizeGroup: '',
    washingLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        gramaj: '',
        bagmm: '',
        sizes: [],
        fabric: [
          {
            name: '',
            mix: [
              { percent: '', type: '' },
              { percent: '', type: '' }
            ]
          }
        ],
        symbol: {},
        additionalPhrases: [
          {
            id: ''
          }
        ],
        washingAdditionalPhrases: [
          {
            id: ''
          }
        ]
      }
    ],
    warningLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    cordLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    addionalLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    emptyLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    beltLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        sizes: [],
      }
    ],
    brandLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        sizes: [],            
      }
    ],
    priceLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        rifd: false,
        sizes: [],  // Pack field'ı dinamik olarak eklenecek
        mix: [
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
        ] 
      }
    ],
    
    zaraHomeLabel11: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        cardType:"",
        piecesNumber:"",
        rifd: false,
        sizes: [],  // Pack field'ı dinamik olarak eklenecek
        mix: [
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
        ] 
      }
    ],
    zaraHomeLabel12: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        cardType:"",
        piecesNumber:"",
        rifd: false,
        sizes: [],  // Pack field'ı dinamik olarak eklenecek
        mix: [
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
        ] 
      }
    ],
  }

  // Normal departman için Formik initial values
  const normalInitialValues = {
    orderNo: '',
    company: '',
    customerOrderNo: '',
    changesForEveryProduct: false,
    season: '',
    country: '',
    brandOrderNo: '',
    supplierNo: '',
    articleNo: '',
    sizeGroup: '',
    washingLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        sizes: [],
        fabric: [
          {
            name: '',
            mix: [
              { percent: '', type: '' },
              { percent: '', type: '' }
            ]
          }
        ],
        symbol: {},
        additionalPhrases: [
          {
            id: ''
          }
        ],
        washingAdditionalPhrases: [
          {
            id: ''
          }
        ]
      }
    ],
    warningLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    cordLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    addionalLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    emptyLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        qauntity:'',
      }
    ],
    beltLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        sizes: [],
      }
    ],
    brandLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        sizes: [],            
      }
    ],
    extraHomeCardLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        sizes: [],            
      }
    ],
    priceLabel: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        cardType:"",
        piecesNumber:"",
        fabric: [
          {
            name: '',
            mix: [
              { percent: '', type: '' },
              { percent: '', type: '' }
            ]
          }
        ],
        symbol: {},
        rifd: false,
        sizes: [],  // Pack field'ı dinamik olarak eklenecek
        mix: [
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
        ] 
      }
    ],
    zaraHomeLabel11: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        cardType:"",
        piecesNumber:"",
        rifd: false,
        sizes: [],  // Pack field'ı dinamik olarak eklenecek
        mix: [
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
        ] 
      }
    ],
    zaraHomeLabel12: [
      {
        customerOrderNo: '',
        colorCode: '',
        referanceCode: '',
        customerOrderDetail: '',
        sizeDefectivePercent: '',
        cardType:"",
        piecesNumber:"",
        fabric: [
          {
            name: '',
            mix: [
              { percent: '', type: '' },
              { percent: '', type: '' }
            ]
          }
        ],
        symbol: {},
        rifd: false,
        sizes: [],  // Pack field'ı dinamik olarak eklenecek
        mix: [
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
         { currency: '', type: '' },
        ] 
      }
    ],
  }

  return (
    <div>
      <div className="mb-5 flex items-center justify-between">
        <MainTitle back>Sipariş Ekle</MainTitle>
        <p className="font-semibold p-2 rounded-lg uppercase">
          {brand.split('_')[1]} / {dept.split('_')[1]} / {subDept}
        </p>
      </div>
      <Formik
        initialValues={brand.split('_')[1] === "ZaraHome" ? specialInitialValues : normalInitialValues}
        validationSchema={createOrderSchema}
      >
        {({ values }) => {
          // Formik values değişikliklerini logla (sadece gerekirse)
          // console.log('Formik Values:', values)
          return (
            <Form className="space-y-5">
              <div className="rounded bg-white p-5 space-y-2">
                <TopSection brand={brand.split('_')[1]}/>
              </div>
              <BottomSection brand={brand.split('_')[1]} dept={dept} subDept={subDept}/>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}
